import angular from 'angular'
import '../../_main/module'
require('./uni-base')
require('./up')

// require("bootstrap")

// select2
// require("select2")
// require("select2/dist/js/i18n/es")

// boostrap
// require("bootstrap-datepicker")
// require("bootstrap-datepicker/js/locales/bootstrap-datepicker.es")

// typeahead  --> uniAuto
// require("typeahead.js")

// toastr
require('angular-toastr/dist/angular-toastr.tpls')

// treasure-overlay
require('angular-treasure-overlay-spinner/src/treasure-overlay-spinner')

// isteven-multi-select
require('isteven-angular-multiselect/isteven-multi-select')

export var $uniPanelMod = angular.module('uniPanel', [
  'uniMain',
  'UP',
  'toastr',
  'treasure-overlay-spinner',
  'isteven-multi-select',
])

// import { DialogFormProxy } from "./up/components/dialog/dialog-form-factory"
// import { TestStore } from "./uni-base/factories/TestStore"

// Exportar TestStore para poder utilizarlo
export * from './uni-base/services/rest-proxy'
export * from './up/components/dialog/dialog-form-factory'

// import "../styles/index.scss"

// exports.up = 1

console.log('============================>')
